// import Welcome from "../../pages/welcome/Welcome.";
import UserList from "../../pages/utenti/UserList";
import CategoryList from "../../pages/categories/CategoryList";
import VideoList from "../../pages/videos/VideoList";
import VideoUploadForm from "../../pages/uploadvideo/VideoUploadForm";
import RecommendedList from "../../pages/recommended/RecommendedList";
import Top5List from "../../pages/top5/Top5List";
import PlaylistList from "../../pages/playlistList/PlaylistList";
import PlaylistManager from "../../pages/playlistManager/PlaylistManager";
import PlaylistCategoryList from "../../pages/playlistCategoryList/PlaylistCategoryList";

import ReportPage from "../../pages/reports/ReportPage";
import VariableList from "../../pages/variable/VariableList";
import ChannelList from "../../pages/channel/ChannelList";
import CreateChannel from "../../pages/createchannel/CreateChannel";
import UserDetailPage from "../../component/UserDetailPage/UserDetailPage";
import HomeRowSeed from "../../pages/homerowseed/HomeRowSeed";

import { PrivateRoute } from "../../component";
import { Routes, Route, Navigate } from "react-router-dom";
const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <PrivateRoute>
          <Navigate to="utenti" replace />
        </PrivateRoute>
      } />
      {/* <Route path="welcome" element={<PrivateRoute><Welcome /></PrivateRoute>} /> */}
      <Route path="homeorder" element={<PrivateRoute><HomeRowSeed /></PrivateRoute>} />
      <Route path="utenti" element={<PrivateRoute><UserList /></PrivateRoute>} />
      <Route path="user/:userId" element={<PrivateRoute><UserDetailPage /></PrivateRoute>} />
      <Route path="categories" element={<PrivateRoute><CategoryList /></PrivateRoute>} />
      <Route path="videos" element={<PrivateRoute><VideoList /></PrivateRoute>} />
      <Route path="uploadVideo" element={<PrivateRoute><VideoUploadForm /></PrivateRoute>} />
      <Route path="recommended" element={<PrivateRoute><RecommendedList /></PrivateRoute>} />
      <Route path="top5" element={<PrivateRoute><Top5List /></PrivateRoute>} />
      <Route path="playlist" element={<PrivateRoute><PlaylistManager /></PrivateRoute>} />
      <Route path="playlist/:id" element={<PrivateRoute><PlaylistList /></PrivateRoute>} />
      <Route path="playlistcategories" element={<PrivateRoute><PlaylistCategoryList /></PrivateRoute>} />
      <Route path="reports" element={<PrivateRoute><ReportPage /></PrivateRoute>} />
      <Route path="variable" element={<PrivateRoute><VariableList /></PrivateRoute>} />
      <Route path="createchannel" element={<PrivateRoute><CreateChannel /></PrivateRoute>} />
      <Route path="channel" element={<PrivateRoute><ChannelList /></PrivateRoute>} />
    </Routes>
  );
};
export default AdminRoutes;